export default {
    audioTrack: null,
    videoTrack: null,
}